import { Typography } from "@mui/material";

export const NowLoading = () => {
  return <Typography variant="body1">Now Loading...</Typography>;
};
